import { InjectionToken } from "@angular/core";

export const WIDTH = new InjectionToken<string>('width');
export const HEIGHT = new InjectionToken<string>('height');
export const ROTATION = new InjectionToken<string>('rotation');